// import React, { useState } from 'react'
// import { Link } from 'react-router-dom'
// import { BsInstagram } from 'react-icons/bs'
// import { BiLogoLinkedin } from 'react-icons/bi'
// import { FaYoutube } from 'react-icons/fa'
// import { FaFacebook } from 'react-icons/fa'
// import appstore from '../Image/appstore.webp'
// import logo from '../Image/logo.webp'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faXTwitter } from '@fortawesome/free-brands-svg-icons'

// // add new function for HTML entity encoded 
// function encodeToHTMLEntities(str) {
//   return String(str)
//     .split("")
//     .map(ch => `&#${ch.charCodeAt(0)};`)
//     .join("");
// }
// function Footer() {
//   const emailPlain = "support@internselite.com";
//   const emailEncoded = encodeToHTMLEntities(emailPlain);

//   return (
//     <>
//       <style>{`
//         .footer{
//           background-color:#eff0ff;
//           width:100%;
//           margin-top:-4px;
//           opacity:1;
//           border-bottom-left-radius:60px;
//           border-bottom-right-radius:60px;
//         }
//         .mobile_footer{
//           background-color:#eff0ff;
//           width:100%;
//           margin-top:-4px;
//           opacity:1;
//           border-bottom-left-radius:40px;
//           border-bottom-right-radius:40px;
//         }
//         .foote_img{
//           width:70%; 
//         }
//         .icon_footer_twitter{
//           font-size:18px;
//           user-select: none;
//         }
//         .foote_text{
//           font-family: 'Poppins', sans-serif;
//           font-size:20px;
//           color:#3d2e7c;
//           user-select: none;
//         }
//         .Border_link_footer{
//           border-bottom:2px solid;
//           width:130px;
//           font-family: 'Poppins', sans-serif;
//           user-select: none;
//         }
//         .footer_link_color{
//           color:#3d2e7c;
//           margin-left:18px;
//           font-size:14px;
//           font-family: 'Poppins', sans-serif;
//           user-select: none;
//         }
//         .footer_link_color a{
//           color:#3d2e7c;
//           text-decoration: none;
//           font-family: 'Poppins', sans-serif;
//           user-select: none;
//         }
//         .footer_link_color h5{
//           color:#3d2e7c;
//           font-family: 'Poppins', sans-serif;
//           user-select: none;
//         }
//         .icon_box{
//           background-color:#eff0ff;
//         }
//         .playstore_icon{
//           width:45%;
//           margin-top:-3px;
//           margin-left:5px;
//         }
//         .appstore_icon{
//           width:40%;
//           margin-left:15px;
//         }
//         .mobile_playstore_icon{
//           width:90%;
//           margin-top:-3px;
//           margin-left:20px;
//         }
//         .mobile_appstore_icon{
//           width:70%;
//         }
//         .mobile_footer_link_color{
//           color:#3d2e7c;
//           font-family: 'Poppins', sans-serif;
//           font-size:18px;
//           user-select: none;
//         }
//         .footer_last_box a{
//           text-decoration: none;
//           font-size:0.9rem;
//           font-family: 'Poppins', sans-serif;
//           user-select: none;
//         }
//         .footer_last_box p{
//           font-size:0.9rem;
//           font-family: 'Poppins', sans-serif;
//           user-select: none;
//         }
//       `}</style>
//       <div className="">
//         {/* ---------------------------mobile view--------------------- */}
//         <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
//         <div className="Footer_Main_box d-sm-block d-md-none">
//           <div className="">
//             <div className="mobile_footer py-4">
//               <div className="container pb-4">
//                 <div className="row">
//                   <div className="col-md-12">
//                     <div className="">
//                       <img
//                         className="foote_img"
//                         src={logo}
//                         alt="InternsElite Logo"
//                         onContextMenu={(e) => e.preventDefault()}
//                       ></img>
//                     </div>
//                     <div>
//                       <h6 className="px-3 mobile_footer_link_color pt-4">
//                         Rule the World With Elite.
//                       </h6>
//                     </div>
//                   </div>

//                   <div className="col-md-12">
//                     <div className="row mt-4">
//                       <div className="col-6">
//                         <div className="d-flex justify-content-start">
//                           <ul className="navbar-nav footer_link_color">
//                             <h5 className="Border_link_footer pb-3">
//                               Quick Links
//                             </h5>
//                             <Link to="/">
//                               <li className="pt-3">
//                                 <a className="" href="">
//                                   Home
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/About-Internselite">
//                               <li className="py-3">
//                                 <a className="" href="">
//                                   About Us
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Privacy-Policy/Refund-Policy">
//                               <li className="">
//                                 <a className="" href="">
//                                   Privacy Policy & Refund Policy
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Terms-and-Conditions">
//                               <li className="py-3">
//                                 <a className="" href="">
//                                   Terms & Conditions
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Blog">
//                               <li className="">
//                                 <a className="" href="">
//                                   Blog
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to='/Certificate-Verify'>
//                               <li className="py-3">
//                                 <a className="" href="">
//                                 Certificate Verify
//                                 </a>
//                               </li>
//                             </Link>
//                           </ul>
//                         </div>
//                       </div>
//                       <div className="col-6">
//                         <div className=" d-flex justify-content-center">
//                           <ul className="navbar-nav footer_link_color">
//                             <h5 className="Border_link_footer pb-3">Courses</h5>
//                             <Link to="/Machine-Learning">
//                               <li className="pt-3">
//                                 <a className="" href="">
//                                   Machine Learning
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Web-Development">
//                               <li className="py-3">
//                                 <a className="" href="">
//                                   Web Development
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Artificial-Intelligence">
//                               <li className="">
//                                 <a className="" href="">
//                                   Artificial Intelligence
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Data-Science">
//                               <li className="py-3">
//                                 <a className="" href="">
//                                   Data Science
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Code-Editor-Page">
//                               <li className="">
//                                 <a className="" href="">
//                                   Code Editor
//                                 </a>
//                               </li>
//                             </Link>
//                           </ul>
//                         </div>
//                       </div>
//                       <div className="col-12 mt-4">
//                         <div className=" d-flex justify-content-center">
//                           <ul className="navbar-nav footer_link_color">
//                             <h5 className="Border_link_footer pb-3">Contact</h5>
//                             <a href="tel:+919318338245">
//                               <li className="pt-3">
//                                 <div>
//                                   <span className=" contact_text ">
//                                     +91 93183 38245 (Available for calls Monday
//                                     to Saturday, 10:30 AM to 7:30 PM. Hours may vary
//                                     on holidays.)
//                                   </span>
//                                 </div>
//                               </li>
//                             </a>
//                             {/* <a href="mailto:support@internselite.com">
//                               <li>
//                                 <div className="pt-2">
//                                   <span className="contact_text">
//                                     support@internselite.com
//                                   </span>
//                                 </div>
//                               </li>
//                             </a> */}
                              
//                                <a href={`mailto:${emailPlain}`}>
//                               <li>
//                                 <div className="pt-2">
//                                   <span className="contact_text" 
//                                   dangerouslySetInnerHTML={{ __html: emailEncoded }}>                                   
//                                   </span>
//                                 </div>
//                               </li>
//                             </a>


//                             {/* <div className="contact-text-address py-3">
//                               <span className="Contact_text">
//                                 2nd Floor, P. D. House Building, Chungi No. - 1,
//                                 Sohna Gurgaon Road, Opp. 4 Season Resort,
//                                 Sector-4, Sohna, Haryana-122103.
//                               </span>
//                             </div> */}
//                             <div className="">
//                               <iframe
//                                 className=""
//                                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.2159924974653!2d77.04158387510864!3d28.41273877578547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d229aba105daf%3A0x74b99d1aa613bad5!2sTower%20B3%2C%20Spaze%20i-Tech%20Park%2C%20Sector%2049%2C%20Gurugram%2C%20Haryana%20122018!5e0!3m2!1sen!2sin!4v1738753694656!5m2!1sen!2sin"
//                                 width="100%"
//                                 height="100"
//                                 allowfullscreen=""
//                                 loading="lazy"
//                                 referrerpolicy="no-referrer-when-downgrade"
//                               ></iframe>
//                             </div>
//                           </ul>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/* <div className="row">
//                 <p className="mobile_footer_link_color px-5 text-center">
//                   Download Our App
//                 </p>
//                 <div className="col-6">
//                   <div className="text-center">
//                     <a
//                       href="https://play.google.com/store/apps/details?id=co.diy.jzlzp"
//                       target="_blank"
//                     >
//                       <img
//                         alt="Get it on Google Play"
//                         className="mobile_playstore_icon"
//                         src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
//                         onContextMenu={(e) => e.preventDefault()}
//                       />
//                     </a>
//                   </div>
//                 </div>
//                 <div className="col-6 pt-2 text-center">
//                   <a
//                     href="https://apps.apple.com/in/app/myinstitute/id1472483563"
//                     target="_blank"
//                   >
//                     <img
//                       alt="App Store Icon"
//                       className="mobile_appstore_icon"
//                       src={appstore}
//                       onContextMenu={(e) => e.preventDefault()}
//                     />
//                   </a>
//                 </div>
//                 <div></div>
//               </div> */}
//             </div>
//             <div className="pt-4">
//               <div className="container">
//                 <div className="row">
//                   <div className="col-md-12 d-flex justify-content-center border-bottom pb-3">
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://www.instagram.com/internselite/"
//                         target="_blank"
//                       >
//                         <BsInstagram size="23px" color="#3d2e7c" />
//                       </a>
//                     </div>
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://www.facebook.com/people/InternsElite/61551386850161/"
//                         target="_blank"
//                       >
//                         <FaFacebook size="23px" color="#3d2e7c" />
//                       </a>
//                     </div>
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://www.linkedin.com/company/internselite/"
//                         target="_blank"
//                       >
//                         <BiLogoLinkedin size="23px" color="#3d2e7c" />
//                       </a>
//                     </div>
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://youtube.com/@Internselite07?feature=shared"
//                         target="_blank"
//                       >
//                         <FaYoutube size="23px" color="#3d2e7c" />
//                       </a>
//                     </div>
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://twitter.com/internselite?t=3ZDl-YQZa3p1tRPfVNvfDw&s=09"
//                         target="_blank"
//                       >
//                         <FontAwesomeIcon
//                           className="icon_footer_twitter"
//                           color="#3d2e7c"
//                           icon={faXTwitter}
//                         />
//                       </a>
//                     </div>
//                   </div>
//                   <div className="col-md-12 pt-3">
//                     <div className="footer_last_box text-center">
//                       <p>
//                         Internselite Edutech Private Limited © 2023-2025. All
//                         Rights Reserved.
//                       </p>
//                     </div>
//                   </div>
//                   <div className="col-md-12 fw-bold footer_last_box text-center">
//                     <a
//                       className="text-center fs-6  text-dark"
//                       href="https://www.snsoft.tech/"
//                       target="_blank"
//                     >
//                       Managed by InnoSN Soft Tech.
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ------------------------desktop view------------------------ */}
//         <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
//         <div className="Footer_Main_box">
//           <div className="d-none d-md-block">
//             <div className="footer py-4">
//               <div className="container pb-2">
//                 <div className="row">
//                   <div className="col-md-4 pt-2">
//                     <div className="pt-2">
//                       <img
//                         className="foote_img"
//                         src={logo}
//                         alt="InternsElite Logo"
//                         title="InternsElite Logo"
//                         onContextMenu={(e) => e.preventDefault()}
//                       ></img>
//                     </div>
//                     <div>
//                       <h5 className=" foote_text  pt-4 pb-3 px-1">
//                         Rule the World With Elite.
//                       </h5>
//                       {/* <div className="row">
//                         <p className="fs-6 footer_link_color">
//                           Download Our App
//                         </p>
//                         <div className="col-12">
//                           <a
//                             href="https://play.google.com/store/apps/details?id=co.diy.jzlzp"
//                             target="_blank"
//                           >
//                             <img
//                               alt="Get it on Google Play"
//                               className="playstore_icon"
//                               src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
//                               onContextMenu={(e) => e.preventDefault()}
//                             />
//                           </a>
//                         </div>
//                         <div className="col-12 pt-2">
//                           <a
//                             href="https://apps.apple.com/in/app/myinstitute/id1472483563"
//                             target="_blank"
//                           >
//                             <img
//                               alt="App Store Icon"
//                               className="appstore_icon"
//                               src={appstore}
//                               title="App Store Icon"
//                               onContextMenu={(e) => e.preventDefault()}
//                             />
//                           </a>
//                         </div>
//                         <div></div>
//                       </div> */}
//                     </div>
//                   </div>

//                   <div className="col-md-8">
//                     <div className="row mt-4">
//                       <div className="col-md-4">
//                         <div className="d-flex justify-content-end">
//                           <ul className="navbar-nav footer_link_color">
//                             <h5 className="Border_link_footer pb-3">
//                               Quick Links
//                             </h5>
//                             <Link to="/">
//                               <li className="pt-4">
//                                 <a className="" href="">
//                                   Home
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/About-Internselite">
//                               <li className="py-3">
//                                 <a className="" href="">
//                                   About Us
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Privacy-Policy/Refund-Policy">
//                               <li className="">
//                                 <a className="" href="">
//                                   Privacy Policy & Refund Policy
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Terms-and-Conditions">
//                               <li className="py-3">
//                                 <a className="" href="">
//                                   Terms & Conditions
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Blog">
//                               <li className="">
//                                 <a className="" href="">
//                                   Blog
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to='/Certificate-Verify'>
//                               <li className="py-3">
//                                 <a className="" href="">
//                                   Certificate Verify
//                                 </a>
//                               </li>
//                             </Link>
//                           </ul>
//                         </div>
//                       </div>
//                       <div className="col-md-4">
//                         <div className=" d-flex justify-content-center">
//                           <ul className="navbar-nav footer_link_color">
//                             <h5 className="Border_link_footer pb-3">Courses</h5>
//                             <Link to="/Machine-Learning">
//                               <li className="pt-4">
//                                 <a className="" href="">
//                                   Machine Learning
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Web-Development">
//                               <li className="py-3">
//                                 <a className="" href="">
//                                   Web Development
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Artificial-Intelligence">
//                               <li className="">
//                                 <a className="" href="">
//                                   Artificial Intelligence
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Data-Science">
//                               <li className="py-3">
//                                 <a className="" href="">
//                                   Data Science
//                                 </a>
//                               </li>
//                             </Link>
//                             <Link to="/Code-Editor-Page">
//                               <li className="">
//                                 <a className="" href="">
//                                   Code Editor
//                                 </a>
//                               </li>
//                             </Link>
//                           </ul>
//                         </div>
//                       </div>
//                       <div className="col-md-4">
//                         <div className=" d-flex justify-content-center">
//                           <ul className="navbar-nav footer_link_color">
//                             <h5 className="Border_link_footer pb-3">Contact</h5>
//                             <a href="tel:+919318338245">
//                               <li className="pt-4">
//                                 <span className=" contact_text ">
//                                   +91 93183 38245 (Available for calls Monday to
//                                   Saturday, 10:30 AM to 7:30 PM. Hours may vary on
//                                   holidays.)
//                                 </span>
//                               </li>
//                             </a>
//                             {/* <a href="mailto:support@internselite.com">
//                               <li>
//                                 <div className="pt-2">
//                                   <span className="contact_text">
//                                     support@internselite.com
//                                   </span>
//                                 </div>
//                               </li>
//                             </a> */}

//                             {/* add new for HTML entity encoded */}
//                            <a href={`mailto:${emailPlain}`}>
//                               <li>
//                                 <div className="pt-2">
//                                   <span className="contact_text" 
//                                   dangerouslySetInnerHTML={{ __html: emailEncoded }}>                                    
//                                   </span>
//                                 </div>
//                               </li>
//                             </a>
//                             {/* <div className="contact-text-address py-4">
//                               <span className="Contact_text">
//                                 2nd Floor, P. D. House Building, Chungi No. - 1,
//                                 Sohna Gurgaon Road, Opp. 4 Season Resort,
//                                 Sector-4, Sohna, Haryana-122103.
//                               </span>
//                             </div> */}
//                             <div className="">
//                               <iframe
//                                 className=""
//                                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.2159924974653!2d77.04158387510864!3d28.41273877578547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d229aba105daf%3A0x74b99d1aa613bad5!2sTower%20B3%2C%20Spaze%20i-Tech%20Park%2C%20Sector%2049%2C%20Gurugram%2C%20Haryana%20122018!5e0!3m2!1sen!2sin!4v1738753694656!5m2!1sen!2sin"
//                                 width="100%"
//                                 height="100"
//                                 allowfullscreen=""
//                                 loading="lazy"
//                                 referrerpolicy="no-referrer-when-downgrade"
//                               ></iframe>
//                             </div>
//                           </ul>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="pt-4">
//               <div className="container">
//                 <div className="row">
//                   <div className="col-md-4">
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://www.instagram.com/internselite/"
//                         target="_blank"
//                       >
//                         <BsInstagram size="23px" color="#3d2e7c" />
//                       </a>
//                     </div>
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://www.facebook.com/people/InternsElite/61551386850161/"
//                         target="_blank"
//                       >
//                         <FaFacebook size="23px" color="#3d2e7c" />
//                       </a>
//                     </div>
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://www.linkedin.com/company/internselite/"
//                         target="_blank"
//                       >
//                         <BiLogoLinkedin size="23px" color="#3d2e7c" />
//                       </a>
//                     </div>
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://youtube.com/@Internselite07?feature=shared"
//                         target="_blank"
//                       >
//                         <FaYoutube size="23px" color="#3d2e7c" />
//                       </a>
//                     </div>
//                     <div className="d-inline mx-3">
//                       <a
//                         href="https://twitter.com/internselite?t=3ZDl-YQZa3p1tRPfVNvfDw&s=09"
//                         target="_blank"
//                       >
//                         <FontAwesomeIcon
//                           className="icon_footer_twitter"
//                           color="#3d2e7c"
//                           icon={faXTwitter}
//                         />
//                       </a>
//                     </div>
//                   </div>
//                   <div className="col-md-5">
//                     <div className="footer_last_box text-center pt-1">
//                       <p>
//                         Internselite Edutech Private Limited © 2023-2025. All
//                         Rights Reserved.
//                       </p>
//                     </div>
//                   </div>
//                   <div className="col-md-3  footer_last_box text-center">
//                     <a
//                       className="px-2 text-dark"
//                       href="https://www.snsoft.tech/"
//                       target="_blank"
//                     >
//                       Managed by InnoSN Soft Tech.
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Footer




import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { BsInstagram } from 'react-icons/bs'
import { BiLogoLinkedin } from 'react-icons/bi'
import { FaYoutube } from 'react-icons/fa'
import { FaFacebook } from 'react-icons/fa'
import appstore from '../Image/appstore.webp'
import logo from '../Image/logo.webp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXTwitter } from '@fortawesome/free-brands-svg-icons'
function encodeToHTMLEntities(str) {
  return String(str)
    .split("")
    .map(ch => `&#${ch.charCodeAt(0)};`)
    .join("");
}
function Footer() {
  const emailPlain = "support@internselite.com";
  const emailEncoded = encodeToHTMLEntities(emailPlain);
  return (
    <>
      <style>{`
        .footer{
          background-color:#eff0ff;
          width:100%;
          margin-top:-4px;
          opacity:1;
          border-bottom-left-radius:60px;
          border-bottom-right-radius:60px;
        }
        .mobile_footer{
          background-color:#eff0ff;
          width:100%;
          margin-top:-4px;
          opacity:1;
          border-bottom-left-radius:40px;
          border-bottom-right-radius:40px;
        }
        .foote_img{
          width:70%;
          margin-top: 0px;
          margin-left: -80px;
        }
        .mobile_foote_img{
          width:70%;
          margin-top: 5px;
          margin-bottom: 10px;
          margin-left: 50px;
        }
        
        .icon_footer_twitter{
          font-size:18px;
          user-select: none;
        }
        .foote_text{
          font-family: 'Poppins', sans-serif;
          font-size:16px;
          color:#3d2e7c;
          margin-top: -17px;
          margin-left: -80px;
          user-select: none;
        }
        .Border_link_footer{
          border-bottom:2px solid;
          width:130px;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
        .footer_link_color{
          color:#3d2e7c;
          margin-left:18px;
          font-size:14px;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
        .footer_link_color a{
          color:#3d2e7c;
          text-decoration: none;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
        .footer_link_color h5{
          color:#3d2e7c;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
        .icon_box{
          background-color:#eff0ff;
        }
        .playstore_icon{
          width:45%;
          margin-top:-3px;
          margin-left:5px;
        }
        .appstore_icon{
          width:40%;
          margin-left:15px;
        }
        .mobile_playstore_icon{
          width:90%;
          margin-top:-3px;
          margin-left:20px;
        }
        .mobile_appstore_icon{
          width:70%;
        }
        .mobile_footer_link_color{
          color:#3d2e7c;
          font-family: 'Poppins', sans-serif;
          font-size:18px;
          user-select: none;
        }
        .footer_last_box a{
          text-decoration: none;
          font-size:0.9rem;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
        .footer_last_box p{
          font-size:0.9rem;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
          .quicklink-shift-left {
           margin-left: -130px; 
           margin-right: 105px;           
        }
           iframe {
          margin-right: 20px;
        }
      `}</style>
      <div className="">
        {/* ---------------------------mobile view--------------------- */}
        <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
        <div className="Footer_Main_box d-sm-block d-md-none">
          <div className="">
            <div className="mobile_footer py-4">
              <div className="container pb-4">
                <div className="row">
                  <div className="col-md-12">
                    <div className="">
                      <img
                        className="mobile_foote_img"
                        src={logo}
                        alt="InternsElite Logo"
                        onContextMenu={(e) => e.preventDefault()}
                      ></img>
                    </div>
                    <div>
                      {/* <h6 className="px-3 mobile_footer_link_color pt-4">
                        Rule the World With Elite.
                      </h6> */}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row mt-4 " >
                      <div className="col-6">
                        <div className="d-flex justify-content-start">
                          <ul className="navbar-nav footer_link_color">
                            <h5 className="Border_link_footer pb-3">
                              Quick Links
                            </h5>
                            <Link to="/">
                              <li className="pt-3">
                                <a className="" href="">
                                  Home
                                </a>
                              </li>
                            </Link>
                            <Link to="/About-Internselite">
                              <li className="py-3">
                                <a className="" href="">
                                  About Us
                                </a>
                              </li>
                            </Link>
                            <Link to="/Privacy-Policy/Refund-Policy">
                              <li className="">
                                <a className="" href="">
                                  Privacy Policy & Refund Policy
                                </a>
                              </li>
                            </Link>
                            <Link to="/Terms-and-Conditions">
                              <li className="py-3">
                                <a className="" href="">
                                  Terms & Conditions
                                </a>
                              </li>
                            </Link>
                            <Link to="/Blog">
                              <li className="">
                                <a className="" href="">
                                  Blog
                                </a>
                              </li>
                            </Link>
                            {/* <Link to='/Certificate-Verify'>
                              <li className="py-3">
                                <a className="" href="">
                                Certificate Verify
                                </a>
                              </li>
                            </Link> */}
                          </ul>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className=" d-flex justify-content-center">
                          <ul className="navbar-nav footer_link_color">
                            <h5 className="Border_link_footer pb-3">Courses</h5>
                            <Link to="/Machine-Learning-With-Python">
                              <li className="pt-3">
                                <a className="" href="">
                                  Machine Learning With Python
                                </a>
                              </li>
                            </Link>
                            <Link to="/Web-Development">
                              <li className="py-3">
                                <a className="" href="">
                                  Web Development
                                </a>
                              </li>
                            </Link>
                            <Link to="/Artificial-Intelligence">
                              <li className="">
                                <a className="" href="">
                                  Artificial Intelligence
                                </a>
                              </li>
                            </Link>
                            <Link to="/Data-Science">
                              <li className="py-3">
                                <a className="" href="">
                                  Data Science
                                </a>
                              </li>
                            </Link>
                            <Link to="/Code-Editor-Page">
                              <li className="">
                                <a className="" href="">
                                  Code Editor
                                </a>
                              </li>
                            </Link>
                          </ul>
                        </div>
                      </div>                      
                        <div className="col-12 mt-4">
                         <div className="d-flex justify-content-start">
                           <ul className="navbar-nav footer_link_color">
                           <h5 className="Border_link_footer pb-3">Contact</h5>      
                           <li className="pt-3">
                        <div>
                          <span className="contact_text fw-bold d-block pb-2">
                           {/* Gurugram Office */}
                          </span>
                        <span className="contact_text d-block">
                          +91 93183 38245
                        </span>
                      <a href={`mailto:${emailPlain}`}>
                      <span
                        className="contact_text d-block pt-1"
                        dangerouslySetInnerHTML={{ __html: emailEncoded }}
                      ></span>
                      </a>
                         <div className="contact-text-address py-2">
                    </div>
                       <div className="pt-2">
                        {/* <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.2159924974653!2d77.04158387510864!3d28.41273877578547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d229aba105daf%3A0x74b99d1aa613bad5!2sTower%20B3%2C%20Spaze%20i-Tech%20Park%2C%20Sector%2049%2C%20Gurugram%2C%20Haryana%20122018!5e0!3m2!1sen!2sin!4v1738753694656!5m2!1sen!2sin"
                          width="100%"
                          height="100"
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        ></iframe> */}
                       {/* <div
                        style={{ backgroundColor: "#f1f1f5ff", padding: "5px 10px", marginTop: "5px", borderRadius: "4px"  }}
                       >
                        <span className="contact_text d-block">Gurugram</span>
                       </div> */}
                      </div>
                    </div>
                 </li>      
                   <li className="pt-2">
                    <div>
                     <span className="contact_text fw-bold d-block pb-0">
                       {/* Bangalore Office */}
                       </span>
                       {/* <span className="contact_text d-block">
                          +91 93183 38245 
                       </span> */}
                      {/* <a href={`mailto:${emailPlain}`}>
                       <span
                         className="contact_text d-block pt-1"
                         dangerouslySetInnerHTML={{ __html: emailEncoded }}
                       ></span>
                     </a> */}
                     <div className="contact-text-address py-2">
                     
                    </div>
                     <div className="pt-2">
                     {/* <iframe
                     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15555.820882237804!2d77.62788714430572!3d12.910599646137673!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae158676985577%3A0xdc6600d2907e90!2sIncubex%20HSR4!5e0!3m2!1sen!2sin!4v1760420571330!5m2!1sen!2sin" 
                      width="100%"
                      height="100"
                       allowFullScreen=""
                       loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                     ></iframe> */}
                     {/* <div
                     style={{ backgroundColor: "#f1f1f5fff", padding: "5px 10px", marginTop: "5px", borderRadius: "4px" }}
                    >
                   <span className="contact_text d-block">Bangalore</span>
                        </div> */}
                       </div>
                      </div>
                    </li>
                   </ul>
                  </div>
                 </div>
              </div>
           </div>
             </div>
              </div>
              {/* <div className="row">
                <p className="mobile_footer_link_color px-5 text-center">
                  Download Our App
                </p>
                <div className="col-6">
                  <div className="text-center">
                    <a
                      href="https://play.google.com/store/apps/details?id=co.diy.jzlzp"
                      target="_blank"
                    >
                      <img
                        alt="Get it on Google Play"
                        className="mobile_playstore_icon"
                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    </a>
                  </div>
                </div>
                <div className="col-6 pt-2 text-center">
                  <a
                    href="https://apps.apple.com/in/app/myinstitute/id1472483563"
                    target="_blank"
                  >
                    <img
                      alt="App Store Icon"
                      className="mobile_appstore_icon"
                      src={appstore}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  </a>
                </div>
                <div></div>
              </div> */}
            </div>
            <div className="pt-4">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-center border-bottom pb-3">
                    <div className="d-inline mx-3">
                      <a
                        href="https://www.instagram.com/internselite/"
                        target="_blank"
                      >
                        <BsInstagram size="23px" color="#3d2e7c" />
                      </a>
                    </div>
                    <div className="d-inline mx-3">
                      <a
                        href="https://www.facebook.com/people/InternsElite/61551386850161/"
                        target="_blank"
                      >
                        <FaFacebook size="23px" color="#3d2e7c" />
                      </a>
                    </div>
                    <div className="d-inline mx-3">
                      <a
                        href="https://www.linkedin.com/company/internselite/"
                        target="_blank"
                      >
                        <BiLogoLinkedin size="23px" color="#3d2e7c" />
                      </a>
                    </div>
                    <div className="d-inline mx-3">
                      <a
                        href="https://youtube.com/@Internselite07?feature=shared"
                        target="_blank"
                      >
                        <FaYoutube size="23px" color="#3d2e7c" />
                      </a>
                    </div>
                    <div className="d-inline mx-3">
                      <a
                        href="https://twitter.com/internselite?t=3ZDl-YQZa3p1tRPfVNvfDw&s=09"
                        target="_blank"
                      >
                        <FontAwesomeIcon
                          className="icon_footer_twitter"
                          color="#3d2e7c"
                          icon={faXTwitter}
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-12 pt-3">
                    <div className="footer_last_box text-center">
                      <p>
                        Internselite Edutech Private Limited © 2023-2025. All
                        Rights Reserved.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-12 fw-bold footer_last_box text-center">
                    <a
                      className="text-center fs-6  text-dark"
                      href="https://www.snsoft.tech/"
                      target="_blank"
                    >
                      Managed by InnoSN Soft Tech.
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ------------------------desktop view------------------------ */}
        <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
        <div className="Footer_Main_box">
          <div className="d-none d-md-block">
            <div className="footer py-4">
              <div className="container pb-2">
                <div className="row">
                  <div className="col-md-3 pt-2">
                    <div className="pt-2">
                      <img
                        className="foote_img"
                        src={logo}
                        alt="InternsElite Logo"
                        title="InternsElite Logo"
                        onContextMenu={(e) => e.preventDefault()}
                      ></img>
                    </div>
                    <div>
                      <h5 className=" foote_text  pt-5 pb-3 px-0">
                        InternsElite empowers students <br/> with skills, mentorship, and real<br/> -world learning.
                      </h5>
                      {/* <div className="row">
                        <p className="fs-6 footer_link_color">
                          Download Our App
                        </p>
                        <div className="col-12">
                          <a
                            href="https://play.google.com/store/apps/details?id=co.diy.jzlzp"
                            target="_blank"
                          >
                            <img
                              alt="Get it on Google Play"
                              className="playstore_icon"
                              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                              onContextMenu={(e) => e.preventDefault()}
                            />
                          </a>
                        </div>
                        <div className="col-12 pt-2">
                          <a
                            href="https://apps.apple.com/in/app/myinstitute/id1472483563"
                            target="_blank"
                          >
                            <img
                              alt="App Store Icon"
                              className="appstore_icon"
                              src={appstore}
                              title="App Store Icon"
                              onContextMenu={(e) => e.preventDefault()}
                            />
                          </a>
                        </div>
                        <div></div>
                      </div> */}
                    </div>
                  </div>

                  <div className="col-md-8">
                    <div className="row mt-4 " style={{ gap: "60px", flexWrap: "nowrap" }}>
                      <div className="col-md-3 quicklink-shift-left">
                        <div className="d-flex justify-content-start">
                          <ul className="navbar-nav footer_link_color">
                            <h5 className="Border_link_footer pb-3">
                              Quick Links
                            </h5>
                            <Link to="/">
                              <li className="pt-4">
                                <a className="" href="">
                                  Home
                                </a>
                              </li>
                            </Link>
                            <Link to="/About-Internselite">
                              <li className="py-3">
                                <a className="" href="">
                                  About Us
                                </a>
                              </li>
                            </Link>
                            <Link to="/Privacy-Policy/Refund-Policy">
                              <li className="">
                                <a className="" href="">
                                  Privacy Policy & Refund Policy
                                </a>
                              </li>
                            </Link>
                            <Link to="/Terms-and-Conditions">
                              <li className="py-3">
                                <a className="" href="">
                                  Terms & Conditions
                                </a>
                              </li>
                            </Link>
                            <Link to="/Blog">
                              <li className="">
                                <a className="" href="">
                                  Blog
                                </a>
                              </li>
                            </Link>
                            {/* <Link to='/Certificate-Verify'>
                              <li className="py-3">
                                <a className="" href="">
                                  Certificate Verify
                                </a>
                              </li>
                            </Link> */}
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-3 quicklink-shift-left">
                        <div className=" d-flex justify-content-start">
                          <ul className="navbar-nav footer_link_color">
                            <h5 className="Border_link_footer pb-3">Courses</h5>
                            <Link to="/Machine-Learning-With-Python">
                              <li className="pt-4">
                                <a className="" href="">
                                  Machine Learning With Python
                                </a>
                              </li>
                            </Link>
                            <Link to="/Web-Development">
                              <li className="py-3">
                                <a className="" href="">
                                  Web Development
                                </a>
                              </li>
                            </Link>
                            <Link to="/Artificial-Intelligence">
                              <li className="">
                                <a className="" href="">
                                  Artificial Intelligence
                                </a>
                              </li>
                            </Link>
                            <Link to="/Data-Science">
                              <li className="py-3">
                                <a className="" href="">
                                  Data Science
                                </a>
                              </li>
                            </Link>
                            <Link to="/Code-Editor-Page">
                              <li className="">
                                <a className="" href="">
                                  Code Editor
                                </a>
                              </li>
                            </Link>
                          </ul>
                        </div>
                      </div>
                  <div className="col-md-3 quicklink-shift-left ">
                    <h5 className="Border_link_footer pb-3 ">Contact</h5>
                      <div className="d-flex justify-content-between">
                        <div className="flex-fill me-5">                         
                           <div className="pt-4">
                           <span className="contact_text">
                            +91 93183 38245 
                           </span>
                          </div>
                  <div className="pt-2">
                    <span className="contact_text" dangerouslySetInnerHTML={{ __html: emailEncoded }}></span>
                  </div>
                  </div>
                  </div>                     
                    </div>                                         
                       <div className="col-md-3 quicklink-shift-left">
                         <div className="d-flex justify-content-start">
                           <ul className="navbar-nav footer_link_color">
                             <h5 className="Border_link_footer pb-3">Locations</h5>
                               {/* <li className="pt-4">
                               <div style={{ backgroundColor: "#f1f1f5ff", padding: "5px 10px", marginTop: "5px", borderRadius: "4px" }}>
                               <span className="contact_text"> Sector 49, Gurugram</span>
                               </div>
                               </li>                  */}
                     {/* <div className="mt-1">
                         <iframe
                           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.2159924974653!2d77.04158387510864!3d28.41273877578547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d229aba105daf%3A0x74b99d1aa613bad5!2sTower%20B3%2C%20Spaze%20i-Tech%20Park%2C%20Sector%2049%2C%20Gurugram%2C%20Haryana%20122018!5e0!3m2!1sen!2sin!4v1738753694656!5m2!1sen!2sin"
                           width="200%"
                           height="100"
                           allowFullScreen=""
                           loading="lazy"
                           referrerPolicy="no-referrer-when-downgrade"
                         ></iframe>
                        </div>                    */}
                          <li className="py-1">
                           <div style={{ backgroundColor: "#f1f1f5ff", padding: "5px 10px", marginTop: "5px", borderRadius: "4px" }}>
                           <span className="contact_text">Sector 6, Bangalore </span>
                        </div>
                        </li>
                         <div className="mt-0">
                          <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.839707184893!2d77.62217290978732!3d12.918021915999818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae148e4c9e8995%3A0x3392cdca1bf93e2d!2sBHIVE%20Workspace%20HSR%20Silk%20Board!5e0!3m2!1sen!2sin!4v1765112746047!5m2!1sen!2sin" 
                          width="200%"
                          height="100"
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          ></iframe>
                         </div>
                       </ul>
                       </div>
                      </div>                   
                    </div>
                  </div>
                </div>
              </div>
            </div>            
            <div className="pt-4">
              <div className="container">
                <div className="row">
                  <div className="col-md-4">
                    <div className="d-inline mx-3">
                      <a
                        href="https://www.instagram.com/internselite/"
                        target="_blank"
                      >
                        <BsInstagram size="23px" color="#3d2e7c" />
                      </a>
                    </div>
                    <div className="d-inline mx-3">
                      <a
                        href="https://www.facebook.com/people/InternsElite/61551386850161/"
                        target="_blank"
                      >
                        <FaFacebook size="23px" color="#3d2e7c" />
                      </a>
                    </div>
                    <div className="d-inline mx-3">
                      <a
                        href="https://www.linkedin.com/company/internselite/"
                        target="_blank"
                      >
                        <BiLogoLinkedin size="23px" color="#3d2e7c" />
                      </a>
                    </div>
                    <div className="d-inline mx-3">
                      <a
                        href="https://youtube.com/@Internselite07?feature=shared"
                        target="_blank"
                      >
                        <FaYoutube size="23px" color="#3d2e7c" />
                      </a>
                    </div>
                    <div className="d-inline mx-3">
                      <a
                        href="https://twitter.com/internselite?t=3ZDl-YQZa3p1tRPfVNvfDw&s=09"
                        target="_blank"
                      >
                        <FontAwesomeIcon
                          className="icon_footer_twitter"
                          color="#3d2e7c"
                          icon={faXTwitter}
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="footer_last_box text-center pt-1">
                      <p>
                        Internselite Edutech Private Limited © 2023-2025. All
                        Rights Reserved.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3  footer_last_box text-center">
                    <a
                      className="px-2 text-dark"
                      href="https://www.snsoft.tech/"
                      target="_blank"
                    >
                      Managed by InnoSN Soft Tech.
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
